import { cn } from "cn";
import { BwMessagesDark, BwMessagesLight } from "@/components/ui/icons";
import ThemeIcon from "@/components/ui/icons/theme-icon";
import { Typography } from "@/components/ui/typography";

export type MessageEmptyProps = {
  className?: string;
};

/**
 * Centered empty state for order / thread message lists (member + office).
 */
export function MessageEmpty({ className }: MessageEmptyProps) {
  return (
    <div
      className={cn(
        /* sorted */
        "flex flex-col items-center justify-start",
        "px-3 pt-6",
        className,
      )}
    >
      <ThemeIcon
        lightIcon={BwMessagesLight}
        darkIcon={BwMessagesDark}
        className="size-24"
      />
      <Typography className="pt-4 mb-1 font-medium text-center">
        No messages yet
      </Typography>
      <Typography className="text-text-dark-high text-center">
        Start the conversation by sending your first message.
      </Typography>
    </div>
  );
}
